// The Agent & Seller form captures a single "name" field; the invite command needs first + last.
// Split on the first space — first token is the first name, the remainder is the last name.
export const splitAgentName = (name = '') => {
  const trimmed = name.trim();
  const spaceIndex = trimmed.indexOf(' ');

  if (spaceIndex === -1) {
    return { firstName: trimmed, lastName: '' };
  }

  return {
    firstName: trimmed.slice(0, spaceIndex),
    lastName: trimmed.slice(spaceIndex + 1).trim(),
  };
};

// Maps the raw `GET /api/advisor-portal-configurations` list to AutocompleteCDS options.
export const toConfigOptions = (configs = []) =>
  configs.map(({ advisorPortalConfigurationId, name }) => ({
    value: advisorPortalConfigurationId,
    name,
  }));

// Auto-selects the sole config when exactly one exists; otherwise no default selection.
export const getDefaultConfigId = (configs = []) =>
  configs.length === 1 ? configs[0].advisorPortalConfigurationId : null;

// AutocompleteCDS option identity — compares by the stable `value` (config id).
export const isOptionEqualToValue = (option, value) => option.value === value?.value;
